module.exports = __webpack_public_path__ + "img/icon-gp-128x128-08-eye.c6a741f9.svg";